import React from 'react';
import './coachHeader.css';
import { useDispatch } from "react-redux";
import { photoFileAction, coachFormAction } from "../../../redux/rootReducer";
import { COACH_FORM_INITIAL } from "../../../redux/initialStateConstant";

const CoachHeader = () => {
    const dispatch = useDispatch();

    return (
        <>
            <div className="button button--add"
                 onClick={ () => {
                     dispatch(coachFormAction({
                         ...COACH_FORM_INITIAL,
                         open: true
                     }));
                     dispatch(photoFileAction(null));
                 } }
            >Добавить тренера</div>
        </>
    );
};

export default CoachHeader;